import React from 'react';
import { TargetIcon } from 'lucide-react';
export function FiveStandResults() {
  return <div className="w-full" style={{
    backgroundColor: '#f8f6f0'
  }} data-id="element-3346">
      <div className="max-w-4xl mx-auto px-4 md:px-8" data-id="element-3347">
        <div className="mb-16" data-id="element-3348">
          <h2 className="text-2xl md:text-3xl font-bold uppercase mb-6" style={{
          fontFamily: 'Oswald, sans-serif',
          color: '#1e3d2f'
        }} data-id="element-3349">
            5-Stand Results
          </h2>
          <div className="bg-white rounded-xl p-6 md:p-8 shadow-sm border" style={{
          borderColor: '#ede9e0'
        }} data-id="element-3350">
            {/* Placeholder for results */}
            <div className="flex flex-col items-center justify-center py-12 rounded-lg" style={{
            backgroundColor: '#f8f6f0',
            border: '2px dashed #d6d0c4'
          }} data-id="element-3351">
              <TargetIcon size={36} style={{
              color: '#c8a84b'
            }} data-id="element-3352" />
              <p className="mt-3 text-base font-medium" style={{
              color: '#4a6a5a',
              fontFamily: 'Inter, sans-serif'
            }} data-id="element-3353">
                5-Stand results will be posted here after each event.
              </p>
              <p className="mt-1 text-sm" style={{
              color: '#7a9a8a',
              fontFamily: 'Inter, sans-serif'
            }} data-id="element-3354">
                Check back after the next scheduled 5-Stand shoot.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>;
}